import { quoteFlexPackPurchase } from '@blocktickets/shared-utils'

function roundMoney(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  return Math.round(n * 100) / 100
}

export function flexPackCustomFeeLines(flexPack) {
  const raw = Array.isArray(flexPack?.customFees) ? flexPack.customFees : []
  return raw
    .map((fee) => {
      const attrs =
        fee?.attributes && typeof fee.attributes === 'object'
          ? fee.attributes
          : fee
      const amount = Number(attrs?.feeAmount ?? attrs?.fee_amount)
      if (!Number.isFinite(amount) || amount <= 0) return null
      const name = String(attrs?.name || 'Custom fee').trim() || 'Custom fee'
      return {
        id: fee?.id ?? attrs?.id ?? name,
        name,
        option: String(attrs?.option || 'amount').toLowerCase(),
        amount,
      }
    })
    .filter(Boolean)
}

function customFeeDollars(line, price) {
  if (line.option === 'percent') {
    return roundMoney((price * line.amount) / 100)
  }
  return line.amount
}

function flexPackPriceBeforeTaxes(flexPack) {
  const base = roundMoney(flexPack?.price)
  const extra = flexPackCustomFeeLines(flexPack).reduce(
    (sum, line) => sum + customFeeDollars(line, base),
    0
  )
  return roundMoney(base + extra)
}

/**
 * Price shown to fans. When the pack includes the organization's tax rate
 * and card fees, this is the checkout total. Otherwise it stays the pack
 * price plus custom fees, and the page must not claim taxes are included.
 */
export function flexPackDisplayPrice(flexPack) {
  const quote = quoteFlexPackPurchase(flexPack)
  if (quote.pricedWithTaxesAndFees) return quote.buyerTotal
  return flexPackPriceBeforeTaxes(flexPack)
}

export function flexPackPriceIncludesTaxesAndFees(flexPack) {
  return quoteFlexPackPurchase(flexPack).pricedWithTaxesAndFees
}
